import { Injectable, ComponentFactoryResolver } from '@angular/core';
import { ComponentLoaderService } from 'app/common/component-loader.service';
import { InformoComponent } from 'app/cities/informo/informo/informo.component';

@Injectable()
export class InformoLoader implements ComponentLoaderService {
  private rootViewContainer;

  constructor(private factoryResolver: ComponentFactoryResolver) {
    this.factoryResolver = factoryResolver;
  }

  setRootViewContainerRef(viewContainerRef) {
    this.rootViewContainer = viewContainerRef;
  }
  loadComponentDynamically() {
    const factory = this.factoryResolver
                        .resolveComponentFactory(InformoComponent);
    const component = factory
      .create(this.rootViewContainer.parentInjector);
    this.rootViewContainer.insert(component.hostView);

    return component;
  }
}



// WEBPACK FOOTER //
// ./src/app/cities/informo/informo-loader.service.ts